<template>
  <v-overlay :value="dialogLoading">
    <v-progress-circular
        indeterminate
        size="64"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  methods: {
    ...mapMutations(["toogleDialogLoading"])
  },
  computed: {
    ...mapState(["app"]),
    dialogLoading: {
      get: function() {
        return this.app.dialogLoading;
      },
      set: function(value) {
        this.toogleDialogLoading(value);
      }
    }
  },
  watch: {
    $route() {
      if (this.dialogLoading) this.dialogLoading = false;
    }
  }
};
</script>
